import { useState } from 'react'
import { CheckCircle2, EyeOff } from 'lucide-react'
import { Button } from '@/components/ui/Button'
import { GestorJornadaCadenciaSelect } from '@/components/Gestores/GestorJornadaCadenciaSelect'
import type { JornadaCadenciaDias } from '@/components/Gestores/gestorJornadaUi'

type Props = {
  loading: boolean
  cadenciaDias: number
  onCadenciaChange: (cadencia: JornadaCadenciaDias) => void
  onSubmit: (body: { realizadaEm: string; notas?: string }) => Promise<void>
  onCancel: () => void
}

export function GestorJornadaRegisterForm({
  loading,
  cadenciaDias,
  onCadenciaChange,
  onSubmit,
  onCancel,
}: Props) {
  const [notas, setNotas] = useState('')
  const [data, setData] = useState(() => new Date().toISOString().slice(0, 10))

  return (
    <div className='border-t border-border/60 bg-white/[0.02] px-3 py-3 sm:px-4'>
      <div className='mb-3 flex flex-wrap items-start justify-between gap-2'>
        <div>
          <p className='text-xs font-medium text-text-primary'>Registrar reunião 1:1 realizada</p>
          <p className='mt-0.5 text-[11px] text-text-muted'>
            Informe a data em que a reunião aconteceu. A próxima será recalculada pelo ciclo abaixo.
          </p>
        </div>
        <span className='inline-flex items-center gap-1 rounded-full bg-white/[0.06] px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-text-muted ring-1 ring-inset ring-white/10'>
          <EyeOff size={11} />
          Só gestor
        </span>
      </div>

      <div className='grid gap-3 sm:grid-cols-2 lg:grid-cols-[140px_11rem_1fr] lg:items-start'>
        <label className='text-xs text-text-muted'>
          Data da reunião
          <input
            type='date'
            value={data}
            onChange={(e) => setData(e.target.value)}
            className='mt-1 block w-full rounded-lg border border-border bg-bg-main px-3 py-2 text-sm text-text-primary'
          />
        </label>

        <GestorJornadaCadenciaSelect value={cadenciaDias} onChange={onCadenciaChange} />

        <label className='text-xs text-text-muted sm:col-span-2 lg:col-span-1'>
          Anotação privada (opcional)
          <textarea
            value={notas}
            onChange={(e) => setNotas(e.target.value)}
            placeholder='Observações internas sobre a conversa…'
            rows={2}
            className='mt-1 block w-full resize-y rounded-lg border border-border bg-bg-main px-3 py-2 text-sm text-text-primary'
          />
          <span className='mt-1 block text-[11px] leading-snug text-text-muted'>
            Vai para anotações privadas — o PJ não visualiza.
          </span>
        </label>
      </div>

      <div className='mt-3 flex flex-wrap justify-end gap-2'>
        <Button type='button' size='sm' variant='ghost' onClick={onCancel}>
          Cancelar
        </Button>
        <Button
          type='button'
          size='sm'
          loading={loading}
          onClick={() =>
            void onSubmit({
              realizadaEm: new Date(`${data}T12:00:00`).toISOString(),
              notas: notas.trim() || undefined,
            })
          }
        >
          <CheckCircle2 size={14} />
          Registrar 1:1
        </Button>
      </div>
    </div>
  )
}
